module.exports = __webpack_public_path__ + "img/Weapon_06.8715bc7d.png";